import { useConsulta } from './sanity';

/**
 * Lo que se repite en varias páginas (correo, agenda, redes): documento
 * "Ajustes del sitio" en Sanity. Los textos de la portada de la home pasaron a
 * "Páginas → Inicio" (src/Data/Paginas/paginaInicio.json). Cada campo vacío
 * cae a su valor de acá, que es el que tenía el código antes del panel.
 */
const POR_DEFECTO = {
    correo: 'contacto@awna.cl',
    agenda: 'https://meet.brevo.com/awna/reunion-de-30-minutos',
    redes: [
        { name: 'LinkedIn', url: 'https://www.linkedin.com/company/awnadigital/' },
        { name: 'Instagram', url: 'https://www.instagram.com/awna_digital/' },
        { name: 'TikTok', url: 'https://www.tiktok.com/@awnadigital' },
        { name: 'YouTube', url: 'https://www.youtube.com/@Awnadigital/videos' },
        { name: 'Facebook', url: 'https://www.facebook.com/profile.php?id=61567877822933' },
    ],
};

const AJUSTES = `*[_id == "ajustes"][0]{
    correo, agenda, "redes": redes[defined(url)]{ "name": red, url },
    seo
}`;

const o = (valor, porDefecto) => (valor && (!Array.isArray(valor) || valor.length) ? valor : porDefecto);

export function useAjustes() {
    const { datos } = useConsulta(AJUSTES, null, null);
    const d = datos || {};
    return {
        correo: o(d.correo, POR_DEFECTO.correo),
        agenda: o(d.agenda, POR_DEFECTO.agenda),
        redes: o(d.redes, POR_DEFECTO.redes),
        // "Google y redes" del sitio: los de la home y el respaldo de las demás páginas
        seo: d.seo || {},
    };
}

const LINKS_POR_DEFECTO = {
    botones: [
        { texto: 'Agendar reunión', url: 'agenda' },
        { texto: 'Análisis de marca', acento: 'gratis', url: '/analisis-360' },
    ],
    mostrarSitio: true,
    vodcasts: [
        { episodio: 'Ep. 01', invitado: 'César Val', video: 'GXXA_LmlexA' },
        { episodio: 'Ep. 02', invitado: 'Daniel Cáceres', video: '762_hRK7hQs' },
        { episodio: 'Ep. 03', invitado: 'Dr. Carlos Mascias', detalle: 'Experiencia de paciente en salud', video: 'iTWMV8vqY30' },
    ],
};

const LINKS = `*[_id == "links"][0]{ botones[]{ texto, acento, url }, mostrarSitio, vodcasts[]{ episodio, invitado, detalle, youtube } }`;

/** ID de un link de YouTube (watch?v=…, youtu.be/…, shorts/… o embed/…). */
export function idYoutube(url = '') {
    const m = String(url).match(/(?:v=|youtu\.be\/|shorts\/|embed\/)([\w-]{11})/);
    return m ? m[1] : '';
}

/** Página /links. Los botones con url "agenda" usan el link de Ajustes. */
export function useLinks() {
    const { agenda } = useAjustes();
    const { datos } = useConsulta(LINKS, null, null);
    const d = datos || {};
    const botones = o(d.botones, LINKS_POR_DEFECTO.botones).map((b) => ({
        ...b,
        url: b.url === 'agenda' ? agenda : b.url,
        externo: /^https?:\/\//.test(b.url === 'agenda' ? agenda : b.url),
    }));
    const vodcasts = d.vodcasts?.length
        ? d.vodcasts.map((v) => ({ ...v, video: idYoutube(v.youtube) })).filter((v) => v.video)
        : LINKS_POR_DEFECTO.vodcasts;
    return { botones, mostrarSitio: d.mostrarSitio ?? LINKS_POR_DEFECTO.mostrarSitio, vodcasts };
}
